import { Component } from '@angular/core';
import { HomeSectionMainComponent } from './home-section-main/home-section-main.component';
import { HomeSectionPcComponent } from './home-section-pc/home-section-pc.component';
import { HomeSectionMovilComponent } from './home-section-movil/home-section-movil.component';
import { HomeSectionPlansComponent } from './home-section-plans/home-section-plans.component';
import { FooterComponent } from '../shared/footer/footer.component';
import { HomeSectionFeatureComponent } from './home-section-feature/home-section-feature.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    HomeSectionFeatureComponent,
    HomeSectionMainComponent,
    HomeSectionPcComponent,
    HomeSectionMovilComponent,
    HomeSectionPlansComponent,
    FooterComponent,
  ],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {}
